module.exports = __webpack_public_path__ + "static/media/Rhys Goldstein.676947c8.png";